import { LucideProps } from 'lucide-react';

/**
 * Filled swatch for an image legend — the hazard-zone mark on the Killwangen
 * flood map (WB-845). Geometry and colour are Vanesa's "purple box icon.svg"
 * from MRKT-1139, kept at its original viewBox so the corner radius stays in
 * proportion at any size.
 *
 * The fill is deliberately not a brand token: a legend swatch restates a colour
 * painted into the artwork it annotates, so it has to track the artwork rather
 * than the UI palette. `color` is accepted for signature parity with the rest
 * of the icon set and intentionally ignored.
 */
export const LegendBoxIcon = ({
  size = 20,
  className,
  ...props
}: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 62.92 45.49"
    fill="none"
    className={className}
    {...props}
  >
    <rect width="62.92" height="45.49" rx="9.08" ry="9.08" fill="#C080B0" />
  </svg>
);
